export const namespace: string = "manager";

export const webTitle: string = "";

export const VERSION_VALUE = 76;

/**表格距离底部的数值（调整表格高度）*/
export const TABLE_MARGIN_BOTTOM: number = 38;
export const TABLE_MARGIN_BOTTOM_BUTTON: number = 40;
export const TAB_TABLE_MARGIN_BOTTOM: number = 120;
export const PRINT_TAB_MARGIN_BOTTOM: number = 200;
export const PRINT_DETAIL_MARGIN_BOTTOM: number = 240;
/**默认表格高度*/
export const TABLE_DEFAULT_HEIGHT: number = 500;
export const PRINT_DEFAULT_HEIGHT: string = "600px";
export const COUNT_TABLE_HEIGHT:number=70;
/**抽屉宽度*/
export const DRAWER_DEFAULT_SIZE: string = "75%";
/**时间数值*/
export const DRAWER_OPEN_TIME_VALUE: number = 600;
export const MESSAGE_SHOW_TIME_VALUE: number = 1000;
export const AUTO_SIZE_TIME_VALUE: number = 800;
export const SET_FOCUS_TIME_VALUE: number = 800;
export const SUBMIT_FIAL_TIME_VALUE: number = 2000;

export const circleUrl: string ="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";

/**提交显示的背景颜色*/
export const LOADING_BACKGROUND:string='rgba(0, 0, 0, 0.7)';